import React from "react";
import QRCode from "react-qr-code";

export default function EtiquetaSheet({ labels }) {
  return (
    <div
      className="print-only w-full flex justify-center items-center overflow-x-auto"
      style={{
        pageBreakInside: "avoid",
        marginTop: 32,
        background: "#fff",
        boxSizing: "border-box",
        minWidth: 0,
        padding: 0,
      }}
    >
      <div
        className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-1 p-2"
        style={{
          width: "100%",
          maxWidth: "900px",
          background: "#fff",
        }}
      >
        {labels.map((data, idx) => (
          <div
            key={idx}
            className="flex flex-row items-center justify-start border border-gray-300 bg-white p-1"
            style={{
              minWidth: 120,
              maxWidth: 180,
              height: 48,
              fontSize: 10,
              boxSizing: "border-box",
              overflow: "hidden",
            }}
          >
            {data ? (
              <>
                <div className="mr-2 flex-shrink-0 flex items-center justify-center">
                  {data.qr ? (
                    <QRCode
                      value={data.qr}
                      size={29}
                      style={{ width: 29, height: 29 }}
                    />
                  ) : data.customText ? (
                    <div
                      className="text-[7px] text-center font-semibold text-gray-700 px-1"
                      style={{
                        width: 29,
                        height: 29,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        wordBreak: "break-word",
                        lineHeight: 1.1,
                      }}
                    >
                      {data.customText}
                    </div>
                  ) : null}
                </div>
                <div className="flex flex-col items-start w-2/3 overflow-hidden">
                  <div
                    className="font-bold text-xs text-left mb-1 w-full break-words"
                    style={{
                      maxHeight: 28,
                      overflow: "hidden",
                      wordBreak: "break-word",
                      whiteSpace: "pre-wrap",
                    }}
                  >
                    {data.name}
                  </div>
                  <div className="text-[8px] leading-tight w-full">
                    {data.useFabricationDate ? "Fab: " : ""}
                    {data.fabrication}
                  </div>
                  <div className="text-[8px] leading-tight w-full">
                    {data.useValidityDate ? "Val: " : ""}
                    {data.validade}
                  </div>
                </div>
              </>
            ) : (
              <div className="flex-1 h-full" />
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
